
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.52 0h3.056v4.093c5.469.03 10.933-.057 16.397.03 1.165-.117 2.08.789 1.973 1.955.086 10.08-.02 20.163.05 30.242-.05 1.034.103 2.18-.495 3.095-.746.532-1.713.466-2.581.507-5.117-.025-10.228-.015-15.344-.015V44H23.38C15.603 42.578 7.803 41.273.008 39.907c-.005-11.936 0-23.873 0-35.804C7.843 2.732 15.684 1.397 23.52 0z","fill":"#2A5699"}}),_c('path',{attrs:{"d":"M26.574 5.629h16.867v32.744H26.574V34.28h13.29v-2.047h-13.29v-2.558h13.29v-2.047h-13.29V25.07h13.29v-2.046h-13.29v-2.558h13.29v-2.047h-13.29v-2.558h13.29v-2.046h-13.29v-2.559h13.29V9.21h-13.29V5.629zm-16.008 9.04c.971-.056 1.942-.097 2.913-.148.68 3.453 1.375 6.901 2.111 10.34.578-3.551 1.217-7.092 1.835-10.637 1.022-.036 2.044-.092 3.062-.154-1.155 4.958-2.167 9.957-3.43 14.883-.854.446-2.132-.02-3.144.052-.68-3.387-1.472-6.754-2.08-10.156-.598 3.305-1.375 6.58-2.06 9.865-.981-.052-1.967-.113-2.954-.18-.848-4.502-1.845-8.974-2.637-13.486.873-.041 1.753-.077 2.627-.108.526 3.259 1.124 6.503 1.584 9.767.722-3.346 1.458-6.692 2.173-10.038z","fill":"#fff"}})])
          )
        }
      }
    